<div
    #scrollContainer
    class="d-flex flex-wrap gap-1 pt-1 pb-1"
    [ngClass]="maxRows() ? ' overflow-y-auto overflow-x-hidden' : ''"
    [style.max-height.px]="maxHeight()"
>
    @for (
        item of itemsToRender();
        track trackByIndex(index, item);
        let index = $index
    ) {
        <div class="input-list me-1">
            @if (canRenderAvatar(item)) {
                <span class="avatar" [ngClass]="size()">
                    <telxl-avatar
                        [name]="getAvatarName(item)"
                        [size]="size()"
                        [variant]="getAvatarVariant(item)"
                    />
                </span>
            }
            <input
                [ngClass]="sizeClass()"
                [class.with-avatar]="canRenderAvatar(item)"
                [class.no-button]="mode().indexOf('remove') === -1"
                class="form-control"
                type="text"
                [class.invalid]="isItemInvalid(index)"
                [ngModelOptions]="{ updateOn: 'blur', standalone: true }"
                [ngModel]="adapter().toText($any(item))"
                (ngModelChange)="onItemChange($event, index)"
                (keydown.enter)="onEnter($event)"
                [disabled]="
                    mode().indexOf('edit') === -1 || lock().includes(index)
                "
            />
            @if (mode().indexOf('remove') !== -1 && !lock().includes(index)) {
                <button
                    type="button"
                    class="btn-delete"
                    (click)="onDelete(index)"
                >
                    ×
                </button>
            }
        </div>
    }
    <div class="d-flex">
        @if (mode().indexOf('add') !== -1) {
            <button
                class="btn btn-transparent d-flex align-items-center"
                type="button"
                [ngClass]="buttonSizeClass()"
                (click)="onAdd()"
                (mouseenter)="addHover.set(true)"
                (mouseleave)="addHover.set(false)"
            >
                <i
                    class="fa-circle-plus"
                    [ngClass]="addHover() ? 'fa-solid' : 'fa-light'"
                ></i>
            </button>
        }
        @if (mode().indexOf('directory') !== -1 && emailMode()) {
            <button
                class="btn btn-transparent d-flex align-items-center"
                type="button"
                [ngClass]="buttonSizeClass()"
                (click)="onDirectory()"
                (mouseenter)="directoryHover.set(true)"
                (mouseleave)="directoryHover.set(false)"
            >
                <i
                    class="fa-address-book"
                    [ngClass]="
                        directoryHover() || active() ? 'fa-solid' : 'fa-light'
                    "
                ></i>
            </button>
        }
    </div>
</div>
